export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-6">关于我们</h2>
          <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
            <p>
              酷看漫画是一个专注韩漫、日漫、国漫的免费在线阅读平台。我们致力于为漫画爱好者打造一个资源丰富、分类清晰、阅读流畅的漫画世界。
            </p>
            <p>
              平台汇集了玄幻、恋爱、热血、悬疑、搞笑、穿越重生等热门类型，每日更新数百话最新内容。无论你是韩漫迷、日漫控还是国漫粉，都能在这里找到心仪的作品。
            </p>
            <p>
              酷看漫画坚持免费阅读理念，无需付费即可畅享海量漫画资源。我们不断优化阅读体验，适配各种设备屏幕，让追更成为一种享受。
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-8 mt-8 pt-8 border-t border-background-200">
            <div className="text-center">
              <div className="text-3xl font-black text-primary-500">3年+</div>
              <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-black text-accent-500">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活读者</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-black text-primary-500">10万+</div>
              <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}